module.exports = __webpack_public_path__ + "img/HomeCIO314.94267b37.png";